module.exports = require("@aofl/cache-manager");